import {
	IFilterDefinition,
	ISelectFilterDefinition,
	ITextFilterDefinition
} from '@evinced-private/ui-common';

import { FilterTypesNames } from 'src/common/consts/app_consts';

const searchFilter: ITextFilterDefinition = {
	id: 'searchValue',
	label: 'Search',
	filterType: 'text',
	defaultValue: '',
	componentProps: {}
};

const osFilter: ISelectFilterDefinition = {
	id: FilterTypesNames.OS,
	label: 'os',
	filterType: 'select',
	defaultValue: [],
	componentProps: {
		placeholder: 'Select OS',
		allSelectedPlaceholder: 'All OS',
		someItemsSelectedText: (numberOfItems: number) => `OS (${numberOfItems})`,
		isMultiple: true,
		className: 'labels-filter-dropdown',
		id: FilterTypesNames.OS,
		label: 'OS',
		listboxWidth: '150px'
	}
};

const appFilter: ISelectFilterDefinition = {
	id: FilterTypesNames.APPS,
	label: 'apps',
	filterType: 'select',
	defaultValue: [],
	componentProps: {
		placeholder: 'Select App',
		allSelectedPlaceholder: 'All Apps',
		someItemsSelectedText: (numberOfItems: number) => `Apps (${numberOfItems})`,
		isMultiple: true,
		className: 'labels-filter-dropdown',
		id: FilterTypesNames.APPS,
		label: 'App',
		listboxWidth: '150px'
	}
};

const versionFilter: ISelectFilterDefinition = {
	id: FilterTypesNames.VERSIONS,
	label: 'versions',
	filterType: 'select',
	defaultValue: [],
	componentProps: {
		placeholder: 'Select Version',
		allSelectedPlaceholder: 'All Versions',
		someItemsSelectedText: (numberOfItems: number) => `Versions (${numberOfItems})`,
		isMultiple: true,
		className: 'labels-filter-dropdown',
		id: FilterTypesNames.VERSIONS,
		label: 'Version',
		listboxWidth: '150px'
	}
};

export const MfaSessionsPageFilterDefinitions: IFilterDefinition[] = [
	searchFilter,
	osFilter,
	appFilter,
	versionFilter
];
